import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppCoreService } from 'src/app/services/app-core.service';
import Swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { SalesInvoiceService } from 'src/app/services/misc/sales/sales.service';
import { InvoiceDeleteActionsRenderer } from '../../../shared/ag-grid/cell-renderers/invoice-delete.componet';
import * as printJS from 'print-js';

import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SupplementaryInvoiceService } from 'src/app/services/misc/supplementary/supplementary.service';
import { IRNStatusRenderer } from '../../../shared/ag-grid/cell-renderers/IRNStatusRenderer';
import { IRNAdditonalDetailsComponent } from '../../supplementary/irnadditonaldetails/irnadditonaldetails.component';
import { Title } from '@angular/platform-browser';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TemplateService } from 'src/app/services/system-config/template/templates.service';
import { AWBService } from 'src/app/services/operations/awb.service';
import { saveAs } from 'file-saver';
import { JobService } from 'src/app/services/job.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class SalesInvoiceListComponent implements OnInit {
  manifestList = [];
  modalForm: FormGroup;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  invoiceTemplateList: any[];
  cellid: any;
  isInvoicePrintModalOpen = false;
  outPutType = 'pdf';
  isActionAllowed = true;
  public isCollapsed = true;
  isCheckboxDisabled = true;
  filteredRows!: any[];
  checkboxRows!: any[];
  areSelected = false;
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    flex: 1,
    sortable: true,
    resizable: false
  };
  gridOptions: GridOptions;
  columnDefs = [
    {
      headerName: 'Invoice No.', field: 'invoicenofull', filter: true,
      checkboxSelection: (params) => !params.data.issuccess, headerCheckboxSelection: true,
      sortable: false, pinned: 'left', minWidth: 180
    },

    {
      headerName: 'Date', field: 'invoicedate', minWidth: 100,
      filter: 'agDateColumnFilter',
      sortable: true,
      comparator: (valueA: string, valueB: string) => {
        if (!valueA || !valueB) return 0; // Handle empty values

        const [dayA, monthA, yearA] = valueA.split('-').map(Number);
        const [dayB, monthB, yearB] = valueB.split('-').map(Number);

        return new Date(yearA, monthA - 1, dayA).getTime() - new Date(yearB, monthB - 1, dayB).getTime();
      },
      filterParams: {
        comparator: (filterDate: Date, cellValue: string) => {
          if (!cellValue) return 0;

          const [day, month, year] = cellValue.split('-').map(Number);
          const cellDate = new Date(year, month - 1, day).setHours(0, 0, 0, 0); // Normalize to start of day
          const filterTime = filterDate.setHours(0, 0, 0, 0); // Normalize to start of day

          if (cellDate < filterTime) return -1;
          if (cellDate > filterTime) return 1;
          return 0;
        },
        browserDatePicker: true,
        defaultOption: 'inRange',
        suppressAndOrCondition: true,
        suppressFilterButton: false,
        buttons: ['reset'],
        inRangeInclusive: true, // Ensures the 'to' date is included
      }
    },
    { headerName: 'Customer', field: 'customer', filter: true, minWidth: 220 },
    { headerName: 'Service Center', field: 'servicecenter', filter: true, minWidth: 220 },
    { headerName: 'Type', field: 'businesstype', filter: true, minWidth: 90 },
    {
      headerName: 'IRN Posted', field: 'irnposted', filter: true,
      cellRenderer: (params) => {
        return params?.data?.irnposted ? `<span class="badge bg-light">Yes</span>` : `<span class="badge bg-primary">No</span>`;
      }
    },
    {
      headerName: 'Status',
      field: 'invoicenofull',
      cellRenderer: IRNStatusRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      pinned: 'right',
      maxWidth: 90,
    },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: InvoiceDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      pinned: 'right',
      maxWidth: 120,
    },
  ];

  rowData = [];
  cellId: number;
  selectedSCId: number;

  constructor(
    public router: Router,
    private appCoreService: AppCoreService,
    private ngxLoaderService: NgxUiLoaderService,
    private invoiceService: SalesInvoiceService,
    private supplementaryInvoiceService: SupplementaryInvoiceService,
    public modalService: NgbModal,
    private formBuilder: FormBuilder,
    private titleService: Title,
    private templateService: TemplateService,
    private awbService: AWBService,
    private jobService: JobService,
  ) {
    titleService.setTitle('Sales');
    this.context = {
      componentParent: this,
      componentName: 'SalesInvoiceListComponent',
      actionConfig: {
        delete: true,
        edit: true,
        print: true,
        lockUnlock: true
      }
    };

    this.gridOptions = {
      pagination: true,
      paginationPageSize: 20,
      domLayout: 'autoHeight',
      rowSelection: 'multiple',
      frameworkComponents: {
        IRNStatusRenderer: IRNStatusRenderer
      }
    } as any
  }

  ngOnInit() {
    this.modalForm = this.formBuilder.group({
      txtInvoiceMessage: [null],
      outPutType: ['pdf'],
      ddlinvoiceTemplate: [null]
    });

    this.checkPermission();
    if (this.permConfig.isViewAllowed) {
      this.appCoreService.SelectedServiceCenter().subscribe((val) => {
        this.selectedSCId = val;
        this.getAllInvoiceList();
      });
      this.bindTemplates();
    }
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    const permission = userData.config.filter(x => x.categoryname === 'Sales');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }



  async printPdfAction(cell: any, printType: string) {
    if(printType === 'multiple'){
      this.isInvoicePrintModalOpen = true;
    }
    this.cellid = cell;
    if (printType === 'awb' || printType === 'POD') {
      this.ngxLoaderService.start();
      this.jobService.add({jobType: 'print', jobCategory: printType, data: cell}).subscribe(res=>{
        if(res){
          this.ngxLoaderService.stop();
          if(res?.success) this.appCoreService.showMessage('Job added to the Queue');
          else res.data?.err_msg && this.appCoreService.showMessage(res.data?.err_msg,'', 'error');
        }
      });
    }
  }

  async updateLock(cell: any) {
    const result = await this.openConfirmationDialog('Are you sure ?', `You want to ${cell.islock ? 'UNLOCK' : 'LOCK'} this invoice.`)
    if (result) {
      try {
        this.ngxLoaderService.start();
        let data = {
          id: cell.id,
          islock: !cell.islock
        }
        this.invoiceService.UpdateLockById(data).subscribe((res: any) => {
          if (res && res.success) {
            this.getAllInvoiceList(true);
            this.ngxLoaderService.stop();
          } else {
            this.ngxLoaderService.stop();
          }
        })
      } catch (e) {
        console.error(e);
        this.ngxLoaderService.stop();
      }
    }
  }

  getAllInvoiceList(refresh = false) {
    try {
      this.ngxLoaderService.start();
      this.invoiceService.GetAllInvoices({ id: this.selectedSCId, refresh: refresh }).subscribe((res: any) => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.rowData = res.data;
          this.areSelected = false;
          // this.gridOptions.api.addEventListener('firstDataRendered', () => {
          //   this.filteredRows = res.data.filter(item => item.businesstype == "B2B");
          //   // this.gridOptions.api.forEachNode(node => {
          //   //   if (this.filteredRows.some(row => row.businesstype === node.data.businesstype)) {
          //   //     node.setSelected(true);
          //   //     node.setData(node.data);                
          //   //   }
          //   // });
          // });

          //this.checkboxRows = res.data;
        } else {
          this.ngxLoaderService.stop();
        }

      })
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  ngOnDestroy(): void {

  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setDomLayout("autoHeight");
    params.api.sizeColumnsToFit();
  }

  errorAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.errAlert('No Access to Edit.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.invoicenofull) {
        const invoiceData = this.rowData.find(item => item.invoicenofull === cell.invoicenofull);
        if (invoiceData) {
          this.openErrorModel(cell.invoicenofull, invoiceData.additionaldetails)
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  openErrorModel(invoicenofull: string, cell: any) {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      centered: true
    };
    const modalRef = this.modalService.open(IRNAdditonalDetailsComponent, ngbModalOptions);
    modalRef.componentInstance.invoiceNo = invoicenofull;
    modalRef.componentInstance.cellData = cell;
  }



  editAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.errAlert('No Access to Edit.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        this.router.navigate(['/invoices/sales/edit', cell.id]);
      }

    } catch (e) {
      console.error(e);
    }

  }
  // printPdfAction(cell: any) {
  //   let full_invoice_no = cell?.invoicenofull;
  //   console.log("full_invoice_no",full_invoice_no);
  //   try {
  //     this.ngxLoaderService.start();
  //     this.invoiceService.printPDF(full_invoice_no).subscribe(res => {
  //       // console.log(res);
  //       if (res && res.success && res.data) {
  //         // Decode the Base64-encoded HTML
  //         const decodedHtml = atob(res.data.base64Output);
  //         // console.log('decodedHtml', decodedHtml);

  //         // Create a DocumentFragment to manipulate the HTML
  //         const fragment = document.createRange().createContextualFragment(decodedHtml);
  //         //select selector to print
  //         const fragmentedHtml = fragment.querySelector('print-section');
  //         //pass to printjs

  //         this.ngxLoaderService.stop();
  //       } else {
  //         this.ngxLoaderService.stop();
  //       }
  //     });
  //   } catch (e) {
  //     console.error(e);
  //     this.ngxLoaderService.stop();
  //   }
  // }

  lockUnlockAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.errAlert('No Access to Edit.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        this.updateLock(cell);
      }

    } catch (e) {
      console.error(e);
    }

  }



  async deleteAction(cell: any) {
    if (!this.permConfig.isDeleteAllowed) {
      this.errAlert('No Access to Delete.');

    }
    else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
      if (cell.islock) return this.appCoreService.showMessage('Cannot delete locked invoice', '', 'error');
      const result = await this.openConfirmationDialog('Are you sure ?', 'You want to delete.', cell.id);
      result ? this.deleteRecord(cell.id) : null;
    }
  }

  deleteRecord(id) {
    try {
      if (id) {
        this.ngxLoaderService.start();
        this.invoiceService.DeleteById(id).subscribe((res) => {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage('Invoice deleted successfully', 'Success', 'success');
            this.getAllInvoiceList(true);
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  }

  async openConfirmationDialog(msg1: any, msg2?: any, id?: number): Promise<boolean> {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      html: msg2 ? `<span>${msg1}</span><br><span>${msg2}</span>` : `<span>${msg1}</span>`,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      return true;
    }
  }

  errAlert(msg: any) {
    Swal.fire({
      icon: 'warning',
      title: 'Oops...',
      text: msg,
    });
  }

  formateDate(datetime: any): string {
    try {
      const timestamp = new Date(datetime);
      const year = timestamp.getFullYear();
      const month = (timestamp.getMonth() + 1).toString().padStart(2, '0');
      const day = timestamp.getDate().toString().padStart(2, '0');
      return `${day}-${month}-${year}`;
    } catch (e) {
      console.error('Error occurred during date parsing:', e);
      return '';
    }
  }

  viewAction(cell) {
    try {
      if (!this.permConfig.isViewAllowed) {
        this.errAlert('No Access to View.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        // this.router.navigate(['/invoices/sales/edit', cell.id]);
        this.router.navigate(['/invoices/sales/view', cell.id]);
      }

    } catch (e) {
      console.error(e);
    }
  }

  onRowSelected() {
    let req = this.gridOptions.api.getSelectedRows();
    this.areSelected = req?.length > 0 ? true : false;
  }

  GetAllIrnConfig() {
    this.ngxLoaderService.start();
    try {
      this.invoiceService.GetAllIrnConfig().subscribe(res => {
        if (res?.success) {
          this.ngxLoaderService.stop();
          return res.data;
        }
      })
    } catch (error) {
      this.ngxLoaderService.stop();
      return [];
    }
    return [];
  }

  //generate IRN api

  generateIRN() {

    let req = this.gridOptions.api.getSelectedRows();
    // console.log("ionvoice selected for IRN :",req);
    const irnData: any = this.invoiceService.GetAllIrnConfig();
    if (irnData.length) {
      // irnData.
    }
    let filteredInvoiceNo = req.map(x => x.invoicenofull);
    //  console.log("filteredInvoiceNo :",filteredInvoiceNo);
    if (filteredInvoiceNo.length > 0) {
      try {

        // filteredInvoiceNo.forEach(async (element) => {
        //   let reqObj = {invoiceno: element};
        //   await this.invoiceService.IRNGenerate(reqObj).subscribe((res) => {
        //     if (res && res.success) {
        //       console.log("genrate IRN response : ",res);
        //     }
        //   });
        // });

        for (var i = 0; i < filteredInvoiceNo.length; i++) {
          let reqObj = { invoiceno: filteredInvoiceNo[i] };
          this.ngxLoaderService.start();
          this.invoiceService.IRNGenerate(reqObj).subscribe((res) => {
            if (res && res.success) {
              // console.log("genrate IRN response : ", res);
            }
          })
        }
        this.ngxLoaderService.stop();

      } catch (e) {
        console.log(e);
        this.ngxLoaderService.stop();
      }
    }
  }

  sendInvoice(e: any) {
    let selectedRows = this.gridOptions.api.getSelectedRows();
    const invoicenofull_array = selectedRows.flatMap(x => x.invoicenofull);
    // console.log('invoicenofull_array', invoicenofull_array);
    try {
      this.ngxLoaderService.start();
      this.invoiceService.eInvoice(invoicenofull_array).subscribe(res => {
        if (res) {
          if (res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.message, 'Success', 'success');
            this.gridOptions.api.deselectAll();
            this.areSelected = true;
          } else {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.message, 'Error', 'error');
          }
        }
      })
    } catch (error) {
      this.ngxLoaderService.stop();
      this.appCoreService.showMessage('Failed to send e-invoice.\nPlease try after sometime.', 'Error', 'error');
    }
  }

  async cancelIRN(event: any) {
    if (event.id) {
      const confirmed = await this.openConfirmationDialog('<span>Are you sure you want to <b>cancel</b> this IRN ?</span>');
      if (confirmed) {
        try {
          this.ngxLoaderService.start();
          this.invoiceService.cancelIRN({ id: event.id }).subscribe((res) => {
            if (res) {
              if (!res.success) {
                this.appCoreService.showMessage(res.data.err_msg, 'Error', 'error');
              }
              if (res.success) {
                this.appCoreService.showMessage('IRN cancelled successfully', 'Success', 'success');
              }
            }
          })
          this.ngxLoaderService.stop();
        } catch (err) {
          console.log(err);
          this.ngxLoaderService.stop();
        }
      }
    }

  }

  hide() {
    //document.body.classList.remove('right-bar-enabled');
    this.isInvoicePrintModalOpen = false;
    this.modalForm.reset();
    this.modalForm.get('outPutType').setValue('pdf');
  }

  printData() {
    let printData: any = {};
    const templateid = this.modalForm.get('ddlinvoiceTemplate').value;

    printData.invoiceType = 'Sales';
    printData.outputformat = this.modalForm.get('outPutType').value;
    printData.invoicemessage = this.modalForm.get('txtInvoiceMessage').value;
    printData.templatename = this.invoiceTemplateList.find(x => x.id === templateid)?.filename;

    const selectedRows = this.gridOptions.api.getSelectedRows();
    printData.invoice_array = selectedRows.map(row => ({
      invoiceno: row.invoicenofull.replace(/\//g, '_'),
      invoicenofull: row.invoicenofull,
      invoiceid: row.id
    }));

    this.hide();
    this.ngxLoaderService.start();

    try {
      this.invoiceService.printPDF(printData).subscribe(res => {
        if (res) {
          this.ngxLoaderService.stop();
          if (res?.success) {
            if (printData.invoice_array.length > 1) {
              const uint8Array = new Uint8Array(res.data?.[0]?.data ?? res.data);
              const zipBlob = new Blob([uint8Array], {
                type: printData.outputformat === 'pdf'
                  ? 'application/pdf'
                  : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              });
              saveAs(zipBlob, `invoice.zip`);
            } else {
              if (printData.outputformat === 'pdf') {
                let pdfString = '';
              
                if (typeof res.data === 'string') {
                  try {
                    const parsed = JSON.parse(res.data);
                    pdfString = parsed?.base64 || parsed?.data || '';
                  } catch {
                    // It might be a raw base64 string (not JSON)
                    pdfString = res.data;
                  }
                } else if (typeof res.data === 'object') {
                  pdfString = res.data?.base64 || res.data?.data || '';
                }
              
                if (pdfString) {
                  printJS({ printable: pdfString, type: 'pdf', base64: true, showModal: true });
                } else {
                  this.appCoreService.showMessage('Unable to load PDF data.', 'Error', 'error');
                }
              } else if (printData.outputformat === 'excel') {
                const link = document.createElement('a');
                link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.data}`;
                const invoice = printData.invoice_array[0];
                link.download = `${invoice.invoicenofull}.xlsx`;
                link.click();
              }
            }
            this.gridOptions.api.deselectAll();
            this.areSelected = false;
          } else this.appCoreService.showMessage('Kindly contact your system administrator.', 'Error', 'error');
        }
      });
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }


  bindTemplates() {
    try {
      this.templateService.getAllTemplates().subscribe((res) => {
        if (res && res.success) {
          this.invoiceTemplateList = res.data.filter(x => x.category.toLowerCase() === 'invoice');
        }
      })
    } catch (error) {
      console.error(error);
    }
  }

}

